export default __webpack_public_path__ + "static/media/telegram.64728354.svg";